import React, { Component } from 'react'
import { connect } from 'react-redux'
import { openNewMarkerModal } from '../../../../store/actions/sketchActions';
import NewDefect from './NewDefect';
import NewElevation from './NewElevation';
import Loader from 'react-loader-spinner';

class NewMarkerWrapper extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isDefectSelected: true,
        }
    }

    handleSelection = (sel) => {
        this.setState({
            isDefectSelected: sel,
        })
    }

    componentDidMount() {
        this.props.openNewMarkerModal();
    }

    render() {
        const { modalWidthMedium, modalTitleStyle, mut, downX, downY, isElevationMap, sketch, containsMap, fileName,defectMarker,defectMarkers, commons } = this.props;
        // console.log(defectMarker,defectMarkers)
        const { isMarkerCreating, isFilesAdded } = sketch;
        const { isDefectSelected } = this.state;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantForm = isElevationMap === true ? <NewDefect defectMarker={defectMarker} defectMarkers={defectMarkers} downX={downX} downY={downY} isElevationMap={true} /> : isDefectSelected ? <NewDefect defectMarker={defectMarker} defectMarkers={defectMarkers} downX={downX} downY={downY} isElevationMap={false} /> : <NewElevation downX={downX} downY={downY} />;
        const relevantComponent = isMarkerCreating ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br></br>
                <p style={textStyle}>{(isFilesAdded ? "Adding your files..." : `Adding your ${isDefectSelected ? `${defectMarker}` : "elevation"}...`)}</p>
                <br></br>
            </React.Fragment>)
            :
            <React.Fragment>{relevantForm}</React.Fragment>

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex flex-row">
                            <div className="align-self-center">
                                <div className="align-self-start">
                                    <h5 style={modalTitleStyle}>Add a { isDefectSelected?defectMarker:'elevation'}:</h5>
                                    {/* <p style={{ fontSize: "10px", color: "GrayText", fontStyle: "italic" }}>Picked coordinates: ({downX}, {downY})</p> */}
                                </div>
                            </div>
                        </div>


                        {/* Since map doesn't exist so no radio button to display */}
                        {containsMap || fileName.length > 0 ?
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <div className="align-self-end mr-4">
                                        <div className="btn-group btn-group-toggle btn-group-sm" data-toggle="buttons">
                                            <label className="btn btn-outline-dark btn-sm active"><input type="radio" name="options" id="option1" autoComplete="off" onClick={() => this.handleSelection(true)} />
                                                {commons.udefectMarker}
                                            </label>

                                            {isElevationMap === false ? <label className="btn btn-outline-dark btn-sm"><input type="radio" name="options" id="option2" autoComplete="off" onClick={() => this.handleSelection(false)} />
                                                {commons.uelevationCategoryKey}
                                            </label> : <React.Fragment />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <React.Fragment />}
                    </div>

                    {/* DISPLAY RELEVANT FORM */}
                    {relevantComponent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        mut: state.marker,
        sketch: state.sketch,
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openNewMarkerModal: () => dispatch(openNewMarkerModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewMarkerWrapper)
